import { call, put } from 'redux-saga/effects';
import STEPS from 'constants/steps';
import { startLoading, stopLoading, setStep } from 'reduxConfig/auth.creators';

export function* authResetPassword({ email }) {
  yield put(startLoading());
  try {
    yield call(window.FIREBASE.resetPassword, email);
    yield put(setStep(STEPS.resetEmailSent));
  } catch {
    yield put(setStep(STEPS.resetEmailSent));
  } finally {
    yield put(stopLoading());
  }
}
